module.exports = __webpack_public_path__ + "img/word2.6a822677.png";